import React, {useEffect} from 'react'
import styles from './styles.module.scss'
import { connect } from 'react-redux'
import { getTestsList } from '../../actions/testing'
import Loader from 'react-loader';


const mapStateToProps = ({testing}) => {
  const { list, loading} = testing
  return {list, loading}
}

const Testing = ({
  getTestsList,
  list,
  loading,
  history
}) => {
  

  useEffect(() => {
    getTestsList()
  }, [])
  
  const goToTest = (id) => () => history.push(`/tests/${id}`)


  const renderLi = ({name, description, id}) => {
    return (
      <li className={styles.test} onClick={goToTest(id)}>
        <h5>{name}</h5>
        <p>{description}</p>
      </li>
    )
  }

  return (
    <Loader loaded={!loading} color='grey'>
      <div className={styles.wrapper}>
        <p className="captions">Список тестов</p>
        <ul>{list?.map(renderLi)}</ul>
      </div>
    </Loader>
  )
}

export default connect(mapStateToProps, {getTestsList})(Testing)


